import script from "./solutionBlock.vue?vue&type=script&lang=js"
export * from "./solutionBlock.vue?vue&type=script&lang=js"

import "./solutionBlock.vue?vue&type=style&index=0&id=6b3c5c82&lang=scss"

const __exports__ = script;

export default __exports__